// This file is auto-generated by @hey-api/openapi-ts

import type { GetAttractionBySlugResponse } from './types.gen';

const attractionScheduleEventSchemaResponseTransformer = (data: any) => {
  if (data.event_dt) {
    data.event_dt = new Date(data.event_dt);
  }
  return data;
};

const attractionCardResponseSchemaResponseTransformer = (data: any) => {
  if (data.schedule) {
    data.schedule = data.schedule.map((item: any) => attractionScheduleEventSchemaResponseTransformer(item));
  }
  return data;
};

export const getAttractionBySlugResponseTransformer = async (data: any): Promise<GetAttractionBySlugResponse> => {
  data = attractionCardResponseSchemaResponseTransformer(data);
  return data;
};
